import {
  Box,
  chakra,
  Flex,
  Heading,
  HStack,
  IconButton,
  Spacer,
  Stack,
  StackDivider,
  useColorModeValue,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { CloseIcon } from 'components/icons';
import React, { PropsWithChildren } from 'react';

export const SIDE_CAR_APP_FRAME_WIDTH = 'var(--chakra-sizes-96)';

type Props = {
  title: string;
  icon: React.ReactElement;
  mobileFlex?: boolean;
  closeOnOverlayClick?: boolean;
  isOpen: boolean;
  onClose: () => void;
};

export const DesktopSideCarAppLayout = ({
  children,
  title,
  icon,
  isOpen,
  onClose,
}: PropsWithChildren<Props>) => {
  const bg = useColorModeValue('gray.50', 'gray.700');
  const border = useColorModeValue('gray.200', 'gray.600');
  return (
    <Flex
      h="100%"
      w={isOpen ? SIDE_CAR_APP_FRAME_WIDTH : 0}
      py={isOpen ? 2 : 0}
      bg={bg}
      borderLeft={isOpen ? '1px solid' : 0}
      borderColor={border}
      transition="width .3s"
    >
      {isOpen && (
        <Stack h="100%" divider={<StackDivider />}>
          <Heading size="xs" px={2}>
            <HStack w="100%" minHeight="40px">
              <chakra.span color="blue.500">{icon}</chakra.span>
              <span>{title}</span>
              <Spacer />
              <IconButton
                icon={<CloseIcon />}
                aria-label={t`Close app`}
                onClick={onClose}
                variant="ghost"
              />
            </HStack>
          </Heading>
          <Stack w={SIDE_CAR_APP_FRAME_WIDTH} h="100%" overflow="auto">
            <Box px={2} h="100%">
              {children}
            </Box>
          </Stack>
        </Stack>
      )}
    </Flex>
  );
};
